export const DOCUMENT_IMAGE_PLACEHOLDER = undefined;
// Matches an absolute Wix static media URL (http or https). These are genuine
// Wix media that should keep flowing through the media resolver, unlike other
// external URLs (which must be rendered as-is). Exported so consumers parsing
// the same payload share one definition instead of duplicating the prefix.
export const WIX_STATIC_MEDIA_URL_REGEX = /^https?:\/\/static\.wixstatic\.com\//i;
export const PRODUCT_IMAGE_PLACEHOLDER = {
    name: 'b49ee3_c1990078a34745ae8e98cdc1bfae1a48~mv2.png',
};
//# sourceMappingURL=DocumentParser.constants.js.map